module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","subjects":"Module"},"en":{"add":"Add","subjects":"Subjects"}}')
  delete Component.options._Ctor
}
